import React from 'react'
import {
  Container,
  Header,
} from 'semantic-ui-react'

const Privacy = () => (
  <Container text style={{ marginTop: '7em' }}>
    <Header as='h1'>Privacy Policy</Header>
    <p>
      This is a single page application that runs entirely in your browser.
      This means that your actions are not visible to us.
      The only information we might collect is the
      standard web server access log.
      This includes the URL of the first page you access
      (e.g., if someone shares a link to some part of this web application with you,
      and you access the application through that link,
      our server will see that first URL).
    </p>
    <p>
      In the future,
      we might start to collect information
      about actions within the application.
      We would do this for the purpose of research,
      to (2) measure the degree of interest in the different parts of the curriculum, and
      to (1) understand how the application is used and thus to improve the application.
    </p>
  </Container>
)

export default Privacy